import { FC } from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid-premium';

import { TableNumericField } from '../../../../../../shared/components/table/styles/styleFields.ts';

/**
 * WA-3633 — pure produced-quantity edit cell.
 *
 * Renders TableNumericField and forwards edits to MUI's editing state via
 * `api.setEditCellValue` ONLY. The field itself normalizes the German-locale
 * comma to a dot and returns a numeric value or null. All commit and
 * row-advance behavior lives at the screen level (processRowUpdate +
 * onCellKeyDown in productionVersionDetails.component.tsx): keeping the cell a
 * single-channel editor is what removes the four-channel commit race that made
 * the four prior point-fixes unstable.
 */
export const ProducedQuantityEditCell: FC<INumberEditCell> = ({ params }) => {
  const { value, field, id, api } = params;

  return (
    <TableNumericField
      returnZero
      autoFocus
      data-testid={`produced-quantity-cell-${id}`}
      slotProps={{
        htmlInput: {
          'data-testid': `produced-quantity-input-${id}`,
        },
      }}
      onChange={(v) => api.setEditCellValue({ id, field, value: v })}
      disableDecrease
      precision={3}
      noTrailingZeros
      defaultValue={value}
    />
  );
};

interface INumberEditCell {
  params: GridRenderCellParams;
}
